module.exports = __webpack_public_path__ + "img/Outline_1.6b981f37.svg";